import request from '@/utils/request'

// 查询CMS文章分类列表
export function listArticleType(query) {
  return request({
    url: '/article/type/list',
    method: 'get',
    params: query
  })
}

// 查询CMS文章分类分页
export function pageArticleType(query) {
  return request({
    url: '/article/type/page',
    method: 'get',
    params: query
  })
}

// 新增CMS文章分类
export function addArticleType(data) {
  return request({
    url: '/article/type/add',
    method: 'post',
    data: data
  })
}

// 编辑CMS文章分类
export function editArticleType(data) {
  return request({
    url: '/article/type/edit',
    method: 'post',
    data: data
  })
}

// 查询CMS文章分类详情
export function getArticleType(id) {
  return request({
    url: '/article/type/detail?id=' + id,
    method: 'get'
  })
}

// 删除CMS文章分类
export function delArticleType(data) {
  return request({
    url: '/article/type/delete',
    method: 'post',
    data: data
  })
}
